import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { morrisvilleConfig } from "./data";

export default function MorrisvillePage() {
  return <CityPageTemplate config={morrisvilleConfig} />;
}